<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('EditSupplierInfo')">
            <edit-individual-supplier></edit-individual-supplier>
          </vs-tab>
          <vs-tab
            :label="$t('UploadDocuments')"
            v-if="
              $tabHasPermission(
                'AssignDocument|UnAssignDocument|GetSupplierDocuments|GetDocumentSettingsByPartyType'
              )
            "
          >
            <documents-upload mode="individual"></documents-upload>
          </vs-tab>

        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import EditIndividualSupplier from "./EditIndividualSupplier.vue";
import DocumentsUpload from "../DocumentsUpload.vue";
export default {
  components: {
    EditIndividualSupplier,
    DocumentsUpload,
  },
};
</script>
<style scoped>
/* .vs-tabs--content {
  background: #101010;
  padding: 0;
} */
</style>
